import React from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Table,
} from "reactstrap";
//import DriversComponent from "../DriversOld/DriversComponent";
import { useMountEffect } from "app/utils/hooks";
import "./Preferences.scss";
import Title from "app/views/commonComponents/Title/Title";
import FieldNameValue from "../../../../commonComponents/FieldNameValue/FieldNameValue";
import Buttons from "app/views/commonComponents/Buttons/Buttons";
import updateAssignments from "../../../../../../assets/images/profile/updateAssignments.svg";
const Preferences = () => {
  return (
    <>
      <div className="preferencesConatiner">
        <div className="profile-title">
          <div style={{ flex: "1" }}>
            <Title name={"Preferences"} type={"card"} />
          </div>
          <div style={{ flex: "" }}>
            <Buttons
              dimensions={"responsive"}
              iconPosition="left"
              buttonType="secondary"
              size="small"
              image={updateAssignments}
            >
              Update Preferences
            </Buttons>
          </div>
        </div>
        <div className="preferencesDetails">
          <div className="preferencesDetailsSection">
            <div className="valueConatiner">
              <FieldNameValue
                fieldName={"Dispatch Range"}
                fileldValue={"49 States + Canada"}
              />
              <FieldNameValue
                fieldName={"Division"}
                fileldValue={"Texas Aggregates"}
              />
              <FieldNameValue
                fieldName={"Location"}
                fileldValue={"Austin,Texas"}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Preferences;
